// extracted by mini-css-extract-plugin
export var container = "ContentSidebar-module--container--3WavB";
export var sidebar = "ContentSidebar-module--sidebar--Pp2oG";
export var isOpen = "ContentSidebar-module--is-open--2BaQu";
export var handle = "ContentSidebar-module--handle--3OhKf";
export var content = "ContentSidebar-module--content--3cFDQ";